import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Contact from '../pages/Contact';
import HomePage from '../pages/Home';
import SolutionsPage from '../pages/Solutions';
import Works from '../pages/Works';

class RootNavigator extends React.Component {
    render() {

        const Routes = RootNavigator.Routes

        return (
            <Router>

                <Route
                    render={({ location }) => (
                        <TransitionGroup>
                            <CSSTransition key={location.key} classNames="fade" timeout={800}>
                                <Switch location={location}>
                                    <Route exact path={Routes.HOME} component={HomePage} />
                                    <Route exact path={Routes.SOLUTIONS} component={SolutionsPage} />
                                    <Route exact path={Routes.SOLUTIONS_ITEM} component={SolutionsPage} />
                                    <Route exact path={Routes.WORKS} component={Works} />
                                    <Route exact path={Routes.CONTACT} component={Contact} />
                                    <Route render={() => <Redirect to={Routes.HOME} />} />
                                </Switch>
                            </CSSTransition>
                        </TransitionGroup>
                    )}
                />

            </Router>
        )
    }
}

RootNavigator.Routes = {
    HOME: '/',
    SOLUTIONS: '/solucoes',
    SOLUTIONS_ITEM: '/solucoes/:item',
    WORKS: '/produtos',
    CONTACT: '/contato',
}

export default RootNavigator;
export const Routes = RootNavigator.Routes



// WEBPACK FOOTER //
// ./src/components/navigation/RootNavigator.js